import SDKMessageBus from '../utility/message-bus';
import { Maybe } from 'maybe-not';
import { TectonResolvedMenuItem } from '../types/index';

export default function resolveMenu(messageBus: SDKMessageBus, moduleId: string) {
    return (
        outletName: string,
        contextValue?: string,
        resolvedType?: string
    ): Promise<TectonResolvedMenuItem[]> => {
        const outletPath = `${moduleId}.${outletName}`;
        return messageBus
            .sendRequest<{ resolvedMenuItems: TectonResolvedMenuItem[] }>(
                'resolveMenu',
                Maybe.just(JSON.stringify({ outletPath, contextValue, resolvedType }))
            )
            .then(response => response.value.resolvedMenuItems);
    };
}
